import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import axios from './plugins/axios';

import Mixins from './plugins/mixins';
import Filters from './plugins/filters';
import './plugins/components';
import "./plugins/vendors";
import "@/assets/global.css";

import vuetify from './plugins/vuetify';
import VuetifyDialog from 'vuetify-dialog';
import 'vuetify-dialog/dist/vuetify-dialog.css';

Vue.config.productionTip = false;
Vue.mixin(Mixins);

Vue.use(VuetifyDialog, {
  context: {
    vuetify
  }
});

Vue.directive('can', {
  bind(el, binding) {
    if (!JSON.parse(localStorage.getItem('permissions'))
      .includes(binding.expression
        .replace(/'/g, "")
        .replace(/"/g, ""))) {
      el.style.display = "none";
    }
  }
});

Vue.directive('notcan', {
  bind(el, binding) {
    if (JSON.parse(localStorage.getItem('permissions'))
      .includes(binding.expression
        .replace(/'/g, "")
        .replace(/"/g, ""))) {
      el.style.display = "none";
    }
  }
});

new Vue({
  router,
  store,
  vuetify,

  created() {
    axios.interceptors.response.use(
      (response) => response,
      (err) => {
        const status = err.response ? err.response.status : null;
        if (status === 401 && err.config && !err.config.__isRetryRequest) {
          store.commit('logOut');
          router.push('/login').catch(() => {});
        } else if (status === 503) {
          Vue.prototype.$dialog.notify.error("النظام في وضع الصيانة حالياً. يرجى المحاولة لاحقاً.", {
            position: "top-right",
            timeout: 5000,
          });
        }
        return Promise.reject(err);
      }
    );

    axios.interceptors.request.use(
      config => {
        const token = localStorage.getItem('token');
        config.headers.Authorization = token;
        return config;
      }
    );
  },
  render: (h) => h(App)
}).$mount('#app');
